module.exports = __webpack_public_path__ + "static/media/23.b25c3319.jpg";